import { useDateStore } from '@/components/DateInput'
import { useGetRoutesForRole } from './useGetRoutesForRole'
import { useGetControlSheetRoutePoints } from '@/modules/ControlSheet/api/useGetControlSheetRoutePoints'
import { useGetControlSheets } from '@/modules/ControlSheet/api/useGetControlSheets'

/**
 * This hook retrieves all necessary data for the Control Sheet based on:
 * - The routes for the workstation the user is currently viewing
 * - The date the user has selected
 */
export const useRetrieveAllControlSheetData = () => {
    const { date: isoDate } = useDateStore()
    const date = isoDate.split('T')[0]
    const { allRoutes, allowEditAnnotations } = useGetRoutesForRole()
    const routesWithPoints = useGetControlSheetRoutePoints(date, allRoutes || [])

    return {
        controlSheets: useGetControlSheets(date, allRoutes ? allRoutes : []),
        routesWithPoints,
        allRoutes,
        allowEditAnnotations,
    }
}
